import { aspenStyles } from "@aspen/Store/Aspen/AspenStyles";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import MobiusPage from "@insite/mobius/Page";
import { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface PageStyles {
    page?: MobiusPageProps;
}
const mapStateToProps = (state: ApplicationState) => {    
    const session = getSession(state);

  return {
    session,    
  };
};
export const pageStyles: PageStyles = {
    page: {
        css: css`
                @media (min-width: 1200px) {
                    max-width: 1310px;
                    padding-left: 20px;
                    padding-right: 20px;
                    margin-bottom: 30px;
                    margin-left: auto;
                    margin-right: auto;
                }
                @media (min-width: 992px) and (max-width: 1199px){
                    max-width: 1310px;
                    padding-left: 0px;
                    padding-right: 0px;
                    margin-left: auto;
                    margin-right: auto;
                }
                ${aspenStyles.cssOverride.css}
            `,
        padding: 0
    }
};

const styles = pageStyles;
type Props = PageProps &
  ReturnType<typeof mapStateToProps> & HasShellContext;
const Page = ({ id, session, shellContext }: Props) => {
    const history = useHistory();
    const { isInShell } = shellContext;
    
  let isSalesRepPage = typeof window !== 'undefined' && window.location.pathname.toLowerCase().includes('salesrepcentral');
  let isquickQuotePage = typeof window !== 'undefined' && window.location.pathname.toLowerCase().includes('quickquotes');
    React.useEffect(() => {
        const handleRedirection = () => {
          
          if (isSalesRepPage) {
            if (!session.isAuthenticated) {
              history.push('SignIn');
            } else if (session?.properties?.salesRepAccess !== 'true') {
              history.push('/');
            }
          }
          if (isquickQuotePage) {
            if (!session.isAuthenticated) {
              history.push('SignIn');
            } else if (session?.properties["salesRepAccess"] != "true" && session?.properties["quickQuoteAccess"] != "true") {
              history.push('/');
            }
          }
        };
        if(!isInShell){
        handleRedirection();
        }
        else{
          isSalesRepPage = false;
          isquickQuotePage = false;
        }
      }, []);

      
    return(!isInShell && (isSalesRepPage && (!session.isAuthenticated || session?.properties["salesRepAccess"] !== 'true')) || 
    (isquickQuotePage && (!session.isAuthenticated || session?.properties["salesRepAccess"] !== 'true'&& session?.properties["quickQuoteAccess"] != "true")) ? null :
    <MobiusPage  {...styles.page}>
        <Zone contentId={id} zoneName="Content" requireRows />
        <Modals />
    </MobiusPage>
    )
};

const pageModule: PageModule = {
    component: connect(mapStateToProps)(withIsInShell(Page)),
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
